import React from 'react'
import LightGrayBgWrapper from '../../../components/common/AffiliateCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper'
import styles from "./Dashboard.module.scss"
import { Col, Row } from 'reactstrap'
import BarChart from '../../../components/common/AffiliateCommonComponents/Graphs/BarChart/Barchat'
import { CircularProgressbar } from 'react-circular-progressbar';

function Dashboard() {
    const barChartData = [
        {
            name: "Jan",
            targetsales: 12,
            realitysales: 14,
        },
        {
            name: "Feb",
            targetsales: 24,
            realitysales: 12,
        },
        {
            name: "Mar",
            targetsales: 24,
            realitysales: 12,
        },
        {
            name: "Apr",
            targetsales: 24,
            realitysales: 12,
        },
    ]
    const achievedData = { value: 80, text: 'achieved', color: '#41B8E4' }
    const remainedData = { value: 40, text: 'remaining', color: 'red' }
    return (
        <LightGrayBgWrapper>
            <div className={styles.heading}>Performance Summary</div>
            <Row className="g-3">
                <Col xl={9} md={12}>
                    <Row className="g-3">
                        <Col className='d-grid' md={4} sm={12}>
                            <div className={styles.card}>
                                <div>Total Clicks</div>
                                <div className={styles.cardText}>1,500</div>
                            </div>
                        </Col>
                        <Col className='d-grid' md={4} sm={12}>
                            <div className={styles.card}>
                                <div>Total Conversions</div>
                                <div className={styles.cardText}>1,500</div>
                            </div>
                        </Col>
                        <Col className='d-grid' md={4} sm={12}>
                            <div className={styles.card}>
                                <div>Last Payout</div>
                                <div className={styles.cardText}>1,500</div>
                            </div>
                        </Col>
                    </Row>
                    <div className={styles.heading}>Recent Activity</div>

                    {/* Picture Cards  */}
                    <Row>
                        <Col className='d-grid' md={6} sm={12}>
                            <div className={styles.picCard}>
                                <div className={styles.picCardText}>
                                    <div>New Referal from</div>
                                    <div>Website</div>
                                </div>
                                <div>
                                    <img
                                        src={require('../../../assets/images/SellerPortalImages/DashboardImages/StoreLogo.png')}
                                        className={styles.img} />
                                    <div>Robert Fox</div>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-grid' md={6} sm={12}>
                            <div className={styles.picCard}>
                                <div className={styles.picCardText}>
                                    <div>New Referal from</div>
                                    <div>Website</div>
                                </div>
                                <div>
                                    <img
                                        src={require('../../../assets/images/SellerPortalImages/DashboardImages/StoreLogo.png')}
                                        className={styles.img} />
                                    <div>Robert Fox</div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className={styles.heading}>Graphic Evaluation</div>
                    <div className={styles.card}>
                        <BarChart
                            data={barChartData}
                            fillColor={"#41B8E4"}
                            secFillColor={"#FFCF00"}
                            dataKey1='targetsales'
                            dataKey2='realitysales'
                            yaxis={true}
                            domain={[0, 30]}
                            ticks={[0, 5, 10, 15, 20, 25, 30]}
                        />
                    </div>
                </Col>

                <Col xl={3} md={12}>
                    <div className={styles.card2}>
                        <div className="d-flex gap-4">
                            <div className={styles.cardText2}>Total Earnings</div>
                            <div className={styles.cardText3}>$1500</div>
                        </div>
                        <div className={styles.cardText4}>This Month</div>
                    </div>
                    <div className={styles.imgCont}>
                        <img className={styles.shoutImg} src={require("../../../assets/images/AffliliatePortal/dbImg.png")} />
                    </div>
                    <div className={styles.shoutCard}>
                        New Campaign
                    </div>
                    <div className={styles.goalCard}>
                        <div className={styles.heading2}>Goal Tracking</div>
                        <div> <span className='fw-bold'>Goal: </span> 200 conversions by end of month </div>
                        <div className='d-flex gap-4 mt-4'>
                            <div className={styles.circularProgress}>
                                <CircularProgressbar
                                    value={achievedData.value}
                                    text={
                                        <tspan>
                                            <tspan x="50%" y="50%">{achievedData.value}%</tspan>
                                        </tspan>
                                    }
                                    strokeWidth={12}
                                    styles={{

                                        path: {
                                            stroke: achievedData.color, // Set the path color
                                            strokeWidth: 12, // Set the width of the progress path (colored part)
                                        },
                                        trail: {
                                            stroke: achievedData.color, // Set the trail color
                                            strokeWidth: 3, // Set the width of the trail (background part)
                                        },
                                        text: {
                                            fill: achievedData.color,
                                            fontSize: '20px',
                                            fontWeight: '600',
                                            textAnchor: 'middle', // Center the text
                                            dominantBaseline: 'middle', // Align the text vertically in the middle
                                        },
                                    }}
                                />
                            </div>
                            <div className='mt-2'>
                                <div>Achieved</div>
                                <div className={styles.circularProgressText}>120</div>
                            </div>
                        </div>

                        <div className='d-flex gap-4 mt-4'>
                        <div className={styles.circularProgress}>
                            <CircularProgressbar
                                value={remainedData.value}
                                text={
                                    <tspan>
                                        <tspan x="50%" y="50%">{remainedData.value}%</tspan>
                                    </tspan>
                                }
                                strokeWidth={12}
                                styles={{

                                    path: {
                                        stroke: remainedData.color, // Set the path color
                                        strokeWidth: 12, // Set the width of the progress path (colored part)
                                    },
                                    trail: {
                                        stroke: remainedData.color, // Set the trail color
                                        strokeWidth: 3, // Set the width of the trail (background part)
                                    },
                                    text: {
                                        fill: remainedData.color,
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        textAnchor: 'middle', // Center the text
                                        dominantBaseline: 'middle', // Align the text vertically in the middle
                                    },
                                }}
                            />
                        </div>
                        <div className='mt-2'>
                                <div>Remained</div>
                                <div className={styles.circularProgressText}>80</div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

        </LightGrayBgWrapper>
    )
}

export default Dashboard
